var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Cloud3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 62,
    viewBox: "0 0 134 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.942 61.6005C137.724 61.6005 138.952 30.1582 118.132 29.136H116.413C112.794 29.1308 109.198 29.6994 105.757 30.8207C104.357 22.3446 99.9664 14.6539 93.3836 9.14862C86.8008 3.64332 78.4639 0.689465 69.8904 0.824762C61.3169 0.96006 53.0769 4.17552 46.6704 9.88582C40.264 15.5961 36.117 23.4215 34.9844 31.9376C27.9683 28.5997 20.0069 27.8294 12.483 29.7607C-5.74854 34.4552 -1.9133 61.6384 16.904 61.6384L116.942 61.6005Z",
    fill: "#A0B9DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Cloud3);
export default __webpack_public_path__ + "static/media/404_cloud_3.cf628d5c681d21decef4cb9f84eaa532.svg";
export { ForwardRef as ReactComponent };